var _circle, _path, _path2, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  stroke: "#EB5757",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 20v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-8",
  stroke: "#EB5757",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 27h6M20 27s9 0 9-13",
  stroke: "#EB5757",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 3,
  stroke: "#EB5757",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 12,
  r: 1,
  fill: "#EB5757"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 12,
  r: 2,
  stroke: "#EB5757",
  strokeWidth: 2
})));
export default SvgIndicator5;